export enum AdminShippingMethodListItemAction {
  Edit,
  Preview,
}
